import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['A pile of lessons you still have to sort and sequence', 'Classroom-style material that feels like homework to kids', 'You build every session from scratch, every week', 'Half the room waiting for a free board', 'You keep paying for it in unpaid hours'];
const withIt = ['A full season already planned, session by session', 'Games, relays and puzzles — not lectures', 'Open the volume, print today’s worksheet, teach it', 'Rotations built for 30 kids and 8 sets', 'Two minutes before club and you’re ready'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-ice" data-id="element-284" data-mp="296ysw32xuwc6">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-285" data-mp="2d7r431vdfbb3">
        <div className="text-center" data-id="element-286" data-mp="30yelqev39fau">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-287" data-mp="30xbw0a9i5iwi">
            Why this isn&apos;t another lesson dump
          </p>
          <h2 id="vs-heading" className="chalk-underline mt-3 font-display text-ink text-[28px] sm:text-5xl" data-id="element-288" data-mp="1tfcxl0fzlhx8">
            Free lessons vs{' '}
            <span className="text-green" data-id="element-289" data-mp="1oe7430ei5qmn">a planned season</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-290" data-mp="236r0zjb271vn">
            Yes, there are free chess lessons and curriculums online. Finding
            lessons was never the hard part — turning them into “what do we do
            in club on Tuesday” is. That’s the part this does for you.
          </p>
        </div>

        {/* "So no / So yes" — el recurso de comparación del producto (coral vs verde) */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-ice-dark shadow-card" data-id="element-291" data-mp="2m1xxipaj32ce">
          <div className="bg-crimson px-3.5 py-4 text-white sm:p-6" data-id="element-292" data-mp="2h34hap3uwx8j">
            <span className="font-display text-2xl leading-none sm:text-3xl" data-id="element-293" data-mp="rqj520q4uosy">
              So no
            </span>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-white/80" data-id="element-294" data-mp="mt0zmkbbqrpp">
              Free lessons &amp; PDFs
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-295" data-mp="2rrh67a4rmtdx">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-white/95 sm:text-sm" data-id="element-296" data-mp="2vtccyu5gtyz3">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-297" data-mp="35s1o842uwl6d">
                    <XIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-298" data-mp="3aql8m01sxowm" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-green px-3.5 py-4 text-white sm:p-6" data-id="element-299" data-mp="3jjy9ppa0rwts">
            <span className="font-display text-2xl leading-none text-white sm:text-3xl" data-id="element-300" data-mp="3jl9dhp3gt4kw">
              So yes
            </span>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-white/85" data-id="element-301" data-mp="3th3246ugkoj1">
              The No-Prep Megapack
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-302" data-mp="7hghzq3v8iht">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-303" data-mp="2fhdgcwe3fja">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-304" data-mp="3pmjs5p8ovkp3">
                    <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-305" data-mp="q5bqovkmf642" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}